module.exports = __webpack_public_path__ + "static/media/agentNotifiedMobile2x.236de314.png";